'use strict';

var axs = require('./axs');
var Heading = axs({
  margin: 0,
  lineHeight: 1.25
})('h2');

module.exports = Heading;


//////////////////
// WEBPACK FOOTER
// ./~/axs/dist/Heading.js
// module id = 102
// module chunks = 0